import { useParams } from "infrastructure/router";
import { Filters, OnboardingApplicationStatus, OnboardingApplicationStepAndFieldStatus } from "consts/onboarding";
import useActions from "features/onboarding/useActions";
import { useApplicationDetailContext } from "../ApplicationDetailProvider";

export const useApplicationStatus = () => {
    const params = useParams();

    const { getState } = useApplicationDetailContext();

    const { updateApplication } = useActions();

    const getApplicationStatus = () => {
        const statuses = Array.from(getState().values()).map(({ response }) => response.data.status);

        if (statuses.includes(OnboardingApplicationStepAndFieldStatus.Rejected)) {
            return OnboardingApplicationStatus.Rejected;
        }

        if (statuses.includes(OnboardingApplicationStepAndFieldStatus.RequestedChanges)) {
            return OnboardingApplicationStatus.RequestedChanges;
        }

        if (statuses.every(status => Object.is(status, OnboardingApplicationStepAndFieldStatus.Approved))) {
            return OnboardingApplicationStatus.Approved;
        }

        return OnboardingApplicationStatus.InReview;
    };

    const updateApplicationStatus = async () => {
        const [request] = updateApplication({
            status: getApplicationStatus(),
            userId: String(params[Filters.pki])
        });

        await request;
    };

    return {
        getApplicationStatus,
        updateApplicationStatus
    };
};

export default useApplicationStatus;
